<template>
  <div>
    <section>
      <b-tabs
        v-model="tabIndex"
        vertical
        content-class="col-12 col-md-8 col-lg-9"
        pills
        nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
        nav-class="nav-left"
      >
        <!-- Listado de planes -->
        <b-tab lazy>
          <template #title>
            <feather-icon
              icon="ListIcon"
              size="18"
              class="mr-1"
            />
            <span class="font-weight-bold">Listado de planes</span>
          </template>

          <planes-list />
        </b-tab>

        <!-- Nuevo plan -->
        <b-tab>
          <template #title>
            <feather-icon
              icon="PlusCircleIcon"
              size="18"
              class="mr-1"
            />
            <span class="font-weight-bold">Nuevo plan de estudios</span>
          </template>

          <!-- Alta nuevo plan (steps) -->
          <edit-plan @refetch-data="tabIndex = 0" />
        </b-tab>
      </b-tabs>
    </section>

  </div>
</template>

<script>
import {
  BTabs,
  BTab,
} from 'bootstrap-vue'
import PlanesList from './components/edicion-plan/PlanesList.vue'
import EditPlan from './components/edicion-plan/components/EditPlan.vue'

export default {
  components: {
    BTabs,
    BTab,
    PlanesList,
    EditPlan,
  },
  data: () => ({
    tabIndex: 0,
  }),
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
